export default __webpack_public_path__ + "static/media/task_ok.5f05c9c1.svg";